import {connect} from 'react-redux';
import {createSelector} from 'reselect';

import {makeMapStateToProps} from '../../../../../helpers/reselectHelpers';
import {TopicCommentUnfurlModel} from '../../../../../models/api/commentUnfurlModel';
import {AppState} from '../../../../../store/appState';
import {getFindTeammate} from '../../../../../store/data/teammates/lazyTeammatesSelectors';
import {CommentViewerTopicUnfurl} from './commentViewerTopicUnfurl';

/*
 * Props.
 */

interface CommentViewerTopicUnfurlContainerProps {
  unfurl: TopicCommentUnfurlModel;
  isInteractionDisabled?: boolean;
}

/*
 * Selectors.
 */

function getOwnerId(_state: AppState, props: CommentViewerTopicUnfurlContainerProps) {
  return props.unfurl.topic?.ownerId;
}

function makeGetTopicUnfurlOwner() {
  return createSelector([getFindTeammate, getOwnerId], (findTeammate, ownerId) => {
    if (!ownerId) {
      return undefined;
    }

    return findTeammate(ownerId, 'CommentViewerTopicUnfurlContainer');
  });
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<CommentViewerTopicUnfurlContainerProps>()(() => ({
  owner: makeGetTopicUnfurlOwner(),
}));

export const CommentViewerTopicUnfurlContainer = connect(mapStateToProps)(CommentViewerTopicUnfurl);
